module.exports = __webpack_public_path__ + "img/canvas.58041cb.svg";